var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const imagesTypes = ["wix-draft-plugin-image", "IMAGE"];
const invalidInlineTypes = [
  ...imagesTypes,
  "wix-draft-plugin-gallery",
  "wix-draft-plugin-html",
  "wix-draft-plugin-video",
  "wix-draft-plugin-giphy",
  "wix-draft-plugin-file-upload"
];
const filterRangesByType = (entityRanges, entityMap, entitiesToRemove) => {
  return entityRanges.filter((entityRange) => {
    const { key } = entityRange;
    const { type: entityType } = entityMap[key] || {};
    return entitiesToRemove.indexOf(entityType) === -1;
  });
};
const inlinePluginsRemover = ({ imagesOnly = false } = {}) => (contentState) => {
  const newBlocks = contentState.blocks.map((block) => {
    const { entityRanges = [], type } = block;
    const isAtomic = type === "atomic";
    let filteredRanges = entityRanges;
    if (!isAtomic) {
      filteredRanges = filterRangesByType(
        entityRanges,
        contentState.entityMap,
        imagesOnly ? imagesTypes : invalidInlineTypes
      );
    }
    return __spreadProps(__spreadValues({}, block), {
      entityRanges: filteredRanges
    });
  });
  return __spreadProps(__spreadValues({}, contentState), {
    blocks: newBlocks
  });
};

export { inlinePluginsRemover as default };
//# sourceMappingURL=inlinePluginsRemover.js.map
